import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class SharedService {
    public isResetPasswordTokenValid: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    public langSubject: Subject<string> = new Subject<string>();
    public isSiteAnnouncementClosed = false;
}
